// extracted by mini-css-extract-plugin
export default {"root":"_2wmMH","badge":"_1eJcN","draft":"_1PlKd","pending-deletion":"_1M5or","pendingDeletion":"_1M5or","need-core":"_1c2QH","needCore":"_1c2QH"};